import { useParams, useNavigate } from "react-router-dom";
import { useModules } from "@/auth/ModulesContext";
import { useApAccountingSettings } from "@/hooks/useAccountingConnected";
import { SupplierPage as SupplierPageView } from "@/components/SupplierPage";

export function SupplierPage() {
  const { supplierId } = useParams<{ supplierId: string }>();
  const navigate = useNavigate();
  const { hasModule, modules } = useModules();
  const accountingConnected = useApAccountingSettings(modules !== null && hasModule("ap.accounting")) !== null;

  if (!supplierId) return null;

  return (
    <SupplierPageView
      accountingConnected={accountingConnected}
      supplierId={supplierId}
      onBack={() => navigate("/suppliers")}
      onBillClick={(billId) => navigate(`/bills/${billId}`)}
      onMatchClick={(billId) => navigate(`/bills/${billId}/match`)}
      onPurchaseOrderClick={(id) => navigate(`/purchase-orders/${id}`)}
      onDeliveryNoteClick={(id) => navigate(`/delivery-notes/${id}`)}
      onCreditNoteClick={(id) => navigate(`/supplier-credit-notes/${id}`)}
    />
  );
}
